<div class="outside-box">
  @if(!production) {
  <div class="dev-banner">
    <p><strong>Development Mode</strong></p>
  </div>
  }
  <div class="inside-box">
    <mat-card class="login-card">
      <div class="logo-container">
        <img src="/logo.png" alt="Company Logo" class="login-logo" />
      </div>

      <mat-card-header>
        <mat-card-title>Verification Code</mat-card-title>
        <mat-card-subtitle>
          A verification code has been sent to your email/phone. Please enter it below to complete login.
        </mat-card-subtitle>
      </mat-card-header>

      <mat-card-content>
        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="login-form">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Verification Code</mat-label>
            <input matInput type="text" formControlName="verificationCode" required autocomplete="off">

          </mat-form-field>

          <div class="form-actions">
            <button mat-flat-button color="primary" type="submit" class="submit-button"
              [disabled]="loginForm.invalid || accountService.isLoading">
              Verify
            </button>
          </div>
        </form>
      </mat-card-content>
      <p>If you haven't received a verification code, please check your email or phone for the code.</p>
      <mat-card-actions class="additional-actions">
        <a routerLink="/new-account-setup" class="action-link">Back to Account Setup</a>
      </mat-card-actions>
    </mat-card>
  </div>
</div>